<template>
    <div id="personal-profile-data">
        <div class="vx-row">
            <div class="vx-col w-full">
                <!-- SOLICITANTE -->
                <div v-if="!guaranteeRequired" id="applicant-detail" class="mb-4 p-2">
                    <h6 class="success bold">SOLICITANTE</h6>
                    <vs-list-item title="CID">{{ applicant.id }}</vs-list-item>
                    <!-- <vs-list-item title="Onboarding">{{ applicant.onboarding_step|| "--" }}</vs-list-item> -->
                    <vs-list>
                        <!-- SOLICITANTE PERSONA MORAL -->
                        <template v-if="isMoral">
                            <vs-list-item title="Nombre">{{ business.name }}</vs-list-item>
                            <vs-list-item title="Email">
                                <EmailableStatusComponent 
                                    :source="user.emailable_verification_response"
                                    type="applicant"
                                    :email="user.email"
                                    :profile_id="user.id">
                                    <template slot="email">
                                        <p @click.stop="showEmails('userEmailsSentListPM')"
                                            class="black bold clickable primary text-sm underline">
                                            {{ user.email || "--" }}
                                        </p>
                                    </template>
                                </EmailableStatusComponent>
                            </vs-list-item>
                            <vs-list-item class="hidden" title="">
                                <user-emails-sent-list ref="userEmailsSentListPM" v-if="user.email" class="mt-2 mr-2"
                                    :userEmail="user.email" :btnConfig="btnConfig" />
                            </vs-list-item>
                            <vs-list-item title="Tel.">{{ business.country_calling_code || "" }} {{
                                phoneFormat(business.new_phone || "")
                            }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ business.country != null ? business.country.name :
                                "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de constitución">{{ business.constitution_date }}</vs-list-item>
                            <vs-list-item title="RFC">{{ business.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Autorización de consulta CDC NIP">
                                {{ business.last_credit_request != null ?
                                    humanizedCompactDate(business.last_credit_request.created_at) : "--" }}
                                <!-- {{ humanizedCompactDate(business.credit_profile.cdc_credit_history_inquiry_authorization_timestamp)||"--" }} -->
                            </vs-list-item>
                            <vs-list-item title="Caducidad de NIP">
                                {{ business.last_credit_request != null ?
                                    dateDiff(business.last_credit_request.created_at, 3) : "--" }}
                                <!-- {{ dateDiff(business.credit_profile.cdc_credit_history_inquiry_authorization_timestamp, 3)||"--" }} -->
                            </vs-list-item>
                            <vs-list-item title="Giro mercantil, actividad u objeto social">
                                <div class="ml-20 text-align-right">
                                    {{ business.business_activity != null ? business.business_activity.name : "--" }}
                                </div>
                            </vs-list-item>
                            <vs-list-item title="Dirección">
                                <div class="ml-20 text-align-right">
                                    {{ address.full_address || "--" }}
                                </div>
                            </vs-list-item>
                            <vs-list-item title="Syntage">
                                <div @click.stop="getSatProfiles(business.rfc)"
                                    class="clickable-img m-0 p-0 primary underline">
                                    {{ business.last_sat_profile != null ?
                                        translateSyntageStatus(business.last_sat_profile.credential_status) :
                                        "Sin realizar" }}
                                </div>
                            </vs-list-item>
                            <div>
                                <stp-button :variant="'applicant'" :id="applicant.id" />
                            </div>
                        </template>
                        <!-- SOLICITANTE PERSONA FÍSICA -->
                        <template v-else>
                            <vs-list-item title="Nombres">{{ personal.first_name }} {{ personal.second_name
                            }}</vs-list-item>
                            <vs-list-item title="Apellido paterno">{{ personal.last_name_1 }}</vs-list-item>
                            <vs-list-item title="Apellido materno">{{ personal.last_name_2 || "--" }}</vs-list-item>
                            <vs-list-item title="Género">{{ translateGender(personal) }}</vs-list-item>
                            <!-- <vs-list-item title="Onboarding">{{ applicant.onboarding_step|| "--" }}</vs-list-item> -->
                            <vs-list-item title="CURP">{{ personal.curp || "--" }}</vs-list-item>
                            <vs-list-item title="RFC">{{ personal.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Autorización de consulta CDC NIP">{{
                                humanizedCompactDate(personal.credit_profile.cdc_credit_history_inquiry_authorization_timestamp)
                                || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Caducidad de NIP">{{
                                dateDiff(personal.credit_profile.cdc_credit_history_inquiry_authorization_timestamp,
                                    3) || "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de nacimiento">{{ personal.birth_date }}</vs-list-item>
                            <vs-list-item title="Estado de nacimiento">{{ personal.birth_state_named }}</vs-list-item>
                            <vs-list-item title="País de nacimiento">{{ personal.origin_country_named }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ personal.citizenship_named }}</vs-list-item>
                            <vs-list-item title="Tel.">
                                {{ personal.country_calling_code || "" }} {{ phoneFormat(personal.new_phone || "") }}
                                <feather-icon v-if="canEdit" @click="openUserPhoneForm()" icon="EditIcon"
                                    svgClasses="h-5 w-5 text-primary ml-2" />
                            </vs-list-item>
                            <vs-list-item title="Email">
                                <EmailableStatusComponent 
                                    :source="user.emailable_verification_response"
                                    type="applicant"
                                    :email="user.email"
                                    :profile_id="user.id">
                                    <template slot="email">
                                        <p @click.stop="showEmails('userEmailsSentListPF')"
                                            class="black bold clickable primary text-sm underline">
                                            {{ user.email || "--" }}
                                        </p>
                                    </template>
                                </EmailableStatusComponent>
                            </vs-list-item>
                            <vs-list-item class="hidden" title="">
                                <user-emails-sent-list ref="userEmailsSentListPF" v-if="user.email" class="mt-2 mr-2"
                                    :userEmail="user.email" :btnConfig="btnConfig" />
                            </vs-list-item>
                            <vs-list-item title="Verificación de identidad">
                                {{ personal.identity_verifications.length > 0 ?
                                    getStatusStr(personal.identity_verifications[0].identity_status) :
                                    "No realizada" }}
                            </vs-list-item>
                            <vs-list-item title="Dashboard METAMAP">
                                <div v-if="personal.identity_verification_dashboard_url != null">
                                    <vs-button target color="dark" radius icon-pack="feather" icon="icon-user"
                                        :href="$sanitizeUrl(personal.identity_verification_dashboard_url)"></vs-button>
                                </div>
                                <label v-else>--</label>
                            </vs-list-item>
                            <vs-list-item title="Dirección">
                                <div class="ml-20 text-align-right">
                                    {{ address.full_address || "--" }}
                                </div>
                            </vs-list-item>
                            <vs-list-item title="Syntage">
                                <div @click.stop="getSatProfiles(personal.rfc)"
                                    class="clickable-img m-0 p-0 primary underline">
                                    {{ personal.last_sat_profile != null ?
                                        translateSyntageStatus(personal.last_sat_profile.credential_status) :
                                        "Sin realizar" }}
                                </div>
                            </vs-list-item>
                            <div>
                                <stp-button :variant="'applicant'" :id="applicant.id" />
                            </div>
                        </template>
                    </vs-list>
                    <vs-divider></vs-divider>
                    <h6 class="success bold"> {{ isMoral ? 'REPRESENTANTE LEGAL' : 'PERFIL SOCIOECONÓMICO' }}</h6>
                    <vs-list>
                        <template v-if="isMoral">
                            <vs-list-item title="Nombres">{{ business_personal.first_name }} {{
                                business_personal.second_name }}</vs-list-item>
                            <vs-list-item title="Apellido paterno">{{ business_personal.last_name_1 }}</vs-list-item>
                            <vs-list-item title="Apellido materno">{{ business_personal.last_name_2 || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Género">{{ translateGender(business_personal) }}</vs-list-item>
                            <vs-list-item title="CURP">{{ business_personal.curp || "--" }}</vs-list-item>
                            <vs-list-item title="RFC">{{ business_personal.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de nacimiento">{{ business_personal.birth_date || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Estado de nacimiento">{{ business_personal.birth_state_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="País de nacimiento">{{ business_personal.origin_country_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ business_personal.citizenship_named }}</vs-list-item>
                            <vs-list-item title="Tel.">{{ business_personal.country_calling_code || "" }} {{
                                phoneFormat(business_personal.new_phone || "") }}</vs-list-item>
                            <!-- <vs-list-item title="Verificación de identidad">
                                <vs-button v-if="business_personal.identity_verification_dashboard_url != null" target color="dark" radius icon-pack="feather" icon="icon-user" :href="$sanitizeUrl(business_personal.identity_verification_dashboard_url)"></vs-button>
                                <label v-else>No realizada</label>
                            </vs-list-item> -->
                            <vs-list-item title="Verificación de identidad">
                                {{
                                    business_personal.identity_verifications.length > 0 ?
                                        getStatusStr(business_personal.identity_verifications[0].identity_status)
                                        : "No realizada"
                                }}
                            </vs-list-item>
                            <vs-list-item title="Dashboard METAMAP">
                                <div v-if="business_personal.identity_verification_dashboard_url != null">
                                    <vs-button target color="dark" radius icon-pack="feather" icon="icon-user"
                                        :href="$sanitizeUrl(business_personal.identity_verification_dashboard_url)"></vs-button>
                                </div>
                                <label v-else>--</label>
                            </vs-list-item>
                            <vs-list-item title="Dirección">
                                <div class="ml-20 text-align-right">
                                    {{ business_personal_address ? business_personal_address.full_address : "--" }}
                                </div>
                            </vs-list-item>
                        </template>
                        <template v-else>
                            <vs-list-item title="Nivel académico">{{ personal.education_level_named }}</vs-list-item>
                            <vs-list-item title="Estado civil">{{ personal.marital_status_named }}</vs-list-item>
                            <vs-list-item title="Dependientes económicos">{{
                                personal.credit_profile.economic_dependents || "--" }}</vs-list-item>
                            <template v-if="personal.marital_status == 2">
                                <vs-list-item title="Nombre del cónyuge">{{ personal.companion_name }}</vs-list-item>
                                <vs-list-item title="Teléfono de cónyuge">{{ phoneFormat(personal.companion_phone)
                                }}</vs-list-item>
                                <vs-list-item title="Correo de cónyuge">
                                    <EmailableStatusComponent
                                        :source="personal.companion_emailable_verification_response">
                                        <template slot="email">
                                            {{ personal.companion_email || "--" }}
                                        </template>
                                    </EmailableStatusComponent>
                                </vs-list-item>
                            </template>
                            <vs-list-item title="Auto propio">{{
                                booleanFormat(personal.credit_profile.has_motorized_vehicles) }}</vs-list-item>
                            <vs-list-item title="Seguro de gastos médicos mayores">{{
                                booleanFormat(personal.credit_profile.major_medical_health_insurance) }}</vs-list-item>
                        </template>
                    </vs-list>
                    <template v-if="!isMoral">
                        <vs-divider></vs-divider>
                        <h6 class="success bold">OCUPACIÓN</h6>
                        <vs-list>
                            <template>
                                <vs-list-item title="Ocupación">{{ personal.occupation.name }}</vs-list-item>
                                <vs-list-item title="Sector">{{ personal.personal_business_activity ?
                                    personal.personal_business_activity.sector_name : "--" }}</vs-list-item>
                                <vs-list-item title="Actividad principal">{{ personal.personal_business_activity ?
                                    personal.personal_business_activity.name : "--" }}</vs-list-item>
                                <div v-if="hasIncomeSources">
                                    <vs-list-item title="Nombre de la empresa">{{ mainIncomeSource.employer
                                    }}</vs-list-item>
                                    <vs-list-item title="Antigüedad (años)">{{ mainIncomeSource.senority }}
                                        año(s)</vs-list-item>
                                    <vs-list-item v-if="mainIncomeSource.phone != null"
                                        title="Teléfono de empleo y extensión">{{
                                            phoneFormatDialCode(mainIncomeSource.phone.country_calling_code +
                                                mainIncomeSource.phone.phone) }}</vs-list-item>
                                </div>
                                <vs-list-item title="Afiliación al IMSS">{{
                                    booleanFormat(personal.credit_profile.social_security_affiliated) }}</vs-list-item>
                            </template>
                        </vs-list>
                    </template>
                </div>
                <!-- OBLIGADO SOLIDARIO -->
                <div v-else id="applicant-detail" class="mb-4 p-2">
                    <h6 class="success bold">OBLIGADO SOLIDARIO</h6>
                    <vs-list>
                        <vs-list-item title="GID">{{ guarantee.id }}</vs-list-item>
                        <vs-list-item title="Onboarding">
                            <div v-if="!editGuarnaateeOnboarding" class="flex">
                                {{ guarantee.guarantee_profile_step }}
                                <feather-icon v-if="canEdit" @click.stop="editGuarnaateeOnboarding = true"
                                    icon="EditIcon" svgClasses="h-5 w-5 primary" class="ml-2 clickable-img" />
                            </div>
                            <div v-else class="flex">
                                <vs-select v-model.lazy="stepSelected">
                                    <vs-select-item v-for="steps in currentStepList" :key="steps.id" :value="steps.id"
                                        :text="steps.name"></vs-select-item>
                                </vs-select>
                                <feather-icon @click.stop="requestUpdateGuaranteeOnboarding()" icon="SaveIcon"
                                    svgClasses="h-5 w-5 primary" class="ml-2 mt-3 clickable-img" />
                            </div>
                        </vs-list-item>
                        <vs-list-item title="Relación con solicitante">
                            <div class="ml-20 text-align-right">
                                {{ guarantee.relation_with_applicant_named }}
                            </div>
                        </vs-list-item>
                        <template v-if="guaranteeIsMoral">
                            <vs-list-item title="Nombre">{{ business.name }}</vs-list-item>
                            <vs-list-item title="Email">
                                <EmailableStatusComponent :source="guarantee.emailable_verification_response">
                                    <template slot="email">
                                        <p @click.stop="showEmails('userEmailsSentListOSPM')"
                                            class="black bold clickable primary text-sm underline">
                                            {{ guarantee.email || "--" }}
                                        </p>
                                    </template>
                                </EmailableStatusComponent>
                            </vs-list-item>
                            <vs-list-item class="hidden" title="">
                                <user-emails-sent-list ref="userEmailsSentListOSPM" v-if="guarantee.email"
                                    class="mt-2 mr-2" :userEmail="guarantee.email" :btnConfig="btnConfig" />
                            </vs-list-item>
                            <vs-list-item title="Tel.">{{ business.country_calling_code || "" }} {{
                                phoneFormat(business.new_phone || "")
                            }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ business.country != null ? business.country.name :
                                "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de constitución">{{ business.constitution_date }}</vs-list-item>
                            <vs-list-item title="RFC">{{ business.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Autorización de consulta CDC NIP">
                                {{ business.last_credit_request != null ?
                                    humanizedCompactDate(business.last_credit_request.created_at) :
                                    "--" }}
                                <!-- {{ humanizedCompactDate(business.credit_profile.cdc_credit_history_inquiry_authorization_timestamp)||"--" }} -->
                            </vs-list-item>
                            <vs-list-item title="Caducidad de NIP">
                                {{ business.last_credit_request != null ?
                                    dateDiff(business.last_credit_request.created_at, 3) : "--" }}
                                <!-- {{ dateDiff(business.credit_profile.cdc_credit_history_inquiry_authorization_timestamp, 3)||"--" }} -->
                            </vs-list-item>
                            <vs-list-item title="Giro mercantil, actividad u objeto social">
                                <div class="ml-20 text-align-right">
                                    {{ business.business_activity != null ? business.business_activity.name : "--" }}
                                </div>
                            </vs-list-item>
                            <vs-list-item title="Dirección">
                                <div class="ml-20 text-align-right">
                                    {{ address.full_address || "--" }}
                                </div>
                            </vs-list-item>
                            <vs-list-item title="Syntage">
                                <div @click.stop="getSatProfiles(business.rfc)"
                                    class="clickable-img m-0 p-0 primary underline">
                                    {{ business.last_sat_profile != null ?
                                        translateSyntageStatus(business.last_sat_profile.credential_status) : "Sin realizar"
                                    }}
                                </div>
                            </vs-list-item>
                        </template>
                        <template v-else>
                            <vs-list-item title="Nombres">{{ personal.first_name }} {{ personal.second_name
                            }}</vs-list-item>
                            <vs-list-item title="Apellido paterno">{{ personal.last_name_1 }}</vs-list-item>
                            <vs-list-item title="Apellido materno">{{ personal.last_name_2 }}</vs-list-item>
                            <vs-list-item title="Género">{{ translateGender(personal) }}</vs-list-item>
                            <vs-list-item title="CURP">{{ personal.curp || "--" }}</vs-list-item>
                            <vs-list-item title="RFC">{{ personal.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de nacimiento">{{ personal.birth_date || "--" }}</vs-list-item>
                            <vs-list-item title="Estado de nacimiento">{{ personal.birth_state_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="País de nacimiento">{{ personal.origin_country_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ personal.citizenship_named || "--" }}</vs-list-item>
                            <vs-list-item title="Tel.">{{ personal.country_calling_code || "" }} {{
                                phoneFormat(personal.new_phone || "") }}</vs-list-item>
                            <vs-list-item title="Email">
                                <EmailableStatusComponent 
                                    :source="guarantee.emailable_verification_response"
                                    type="guarantee"
                                    :email="guarantee.email"
                                    :profile_id="guarantee.id"
                                >
                                    <template slot="email">
                                        <p @click.stop="showEmails('userEmailsSentListOSPF')"
                                            class="black bold clickable primary text-sm underline">
                                            {{ guarantee.email || "--" }}
                                        </p>
                                    </template>
                                </EmailableStatusComponent>
                            </vs-list-item>
                            <vs-list-item class="hidden" title="">
                                <user-emails-sent-list ref="userEmailsSentListOSPF" v-if="guarantee.email"
                                    class="mt-2 mr-2" :userEmail="guarantee.email" :btnConfig="btnConfig" />
                            </vs-list-item>
                            <vs-list-item title="Consulta CDC">{{ personal.last_credit_request != null ?
                                humanizedCompactDate(personal.last_credit_request.created_at) : "--" }}</vs-list-item>
                            <vs-list-item title="Verificación de identidad">
                                {{ personal.identity_verifications.length > 0 ?
                                    getStatusStr(personal.identity_verifications[0].identity_status) : "No realizada" }}
                            </vs-list-item>
                            <vs-list-item title="Dashboard METAMAP">
                                <div v-if="personal.identity_verification_dashboard_url != null">
                                    <vs-button target color="dark" radius icon-pack="feather" icon="icon-user"
                                        :href="$sanitizeUrl(personal.identity_verification_dashboard_url)"></vs-button>
                                </div>
                                <label v-else>--</label>
                            </vs-list-item>
                            <vs-list-item title="Dirección">
                                <div class="ml-20 text-align-right ">
                                    {{ guaranteeAddress ? guaranteeAddress.full_address : "--" }}
                                </div>
                            </vs-list-item>
                        </template>
                    </vs-list>
                    <div v-if="!guaranteeIsMoral">
                        <vs-divider></vs-divider>
                        <h6 class="success bold">ACCIONES</h6>
                        <div class="flex">
                            <vs-button @click.stop="executeRequestGuaranteeReminder(guarantee.id, 1)" class="mr-2"
                                color="warning" size="small">NOTIFICAR ONBOARDING DE OS</vs-button>
                            <!-- <vs-button @click.stop="executeRequestGuaranteeReminder(guarantee.id, 2)" size="small">HISTORIAL CREDITICIO</vs-button> -->
                            <vs-button v-if="canEdit" @click="goToCdcService(personal.id)"
                                class="flex-none ml-auto mt-2 mr-4 text-black" color="secondary">Ir al buro de
                                crédito</vs-button>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                    <h6 class="success bold"> {{ guaranteeIsMoral ? 'REPRESENTANTE LEGAL' : 'PERFIL SOCIOECONÓMICO' }}
                    </h6>
                    <vs-list>
                        <template v-if="guaranteeIsMoral">
                            <vs-list-item title="Nombres">{{ business_personal.first_name }} {{
                                business_personal.second_name }}</vs-list-item>
                            <vs-list-item title="Apellido paterno">{{ business_personal.last_name_1 }}</vs-list-item>
                            <vs-list-item title="Apellido materno">{{ business_personal.last_name_2 }}</vs-list-item>
                            <vs-list-item title="Género">{{ translateGender(business_personal) }}</vs-list-item>
                            <vs-list-item title="CURP">{{ business_personal.curp || "--" }}</vs-list-item>
                            <vs-list-item title="RFC">{{ business_personal.rfc || "--" }}</vs-list-item>
                            <vs-list-item title="Fecha de nacimiento">{{ business_personal.birth_date || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Estado de nacimiento">{{ business_personal.birth_state_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="País de nacimiento">{{ business_personal.origin_country_named || "--"
                            }}</vs-list-item>
                            <vs-list-item title="Nacionalidad">{{ business_personal.citizenship_named }}</vs-list-item>
                            <vs-list-item title="Tel.">{{ business_personal.country_calling_code || "" }} {{
                                phoneFormat(business_personal.new_phone || "") }}</vs-list-item>
                            <!-- <vs-list-item title="Verificación de identidad">
                                <vs-button v-if="business_personal.identity_verification_dashboard_url != null" target color="dark" radius icon-pack="feather" icon="icon-user" :href="$sanitizeUrl(business_personal.identity_verification_dashboard_url)"></vs-button>
                                <label v-else>No realizada</label>
                            </vs-list-item> -->
                            <vs-list-item title="Verificación de identidad">
                                {{ business_personal.identity_verifications.length > 0 ?
                                    getStatusStr(business_personal.identity_verifications[0].identity_status) :
                                    "No realizada"
                                }}
                            </vs-list-item>
                            <vs-list-item title="Dashboard METAMAP">
                                <div v-if="business_personal.identity_verification_dashboard_url != null">
                                    <vs-button target color="dark" radius icon-pack="feather" icon="icon-user"
                                        :href="$sanitizeUrl(business_personal.identity_verification_dashboard_url)"></vs-button>
                                </div>
                                <label v-else>--</label>
                            </vs-list-item>
                            <vs-list-item title="Dirección" class="mb-4">
                                <div class="ml-20 text-align-right">
                                    {{ guaranteeOwnerAddress.full_address || "--" }}
                                </div>
                            </vs-list-item>
                            <h6 class="success bold">ACCIONES</h6>
                            <div class="flex">
                                <vs-button @click.stop="executeRequestGuaranteeReminder(guarantee.id, 1)" class="mr-2"
                                    color="warning" size="small">NOTIFICAR ONBOARDING DE OS</vs-button>
                                <vs-button @click="goToCdcService(business_personal.id)"
                                    class="flex-none mt-2 mr-4 text-black" color="secondary">Ir al buro de
                                    crédito</vs-button>
                            </div>
                        </template>
                        <template v-else>
                            <vs-list-item title="Nivel académico">{{ personal.education_level_named }}</vs-list-item>
                            <vs-list-item title="Estado civil">{{ personal.marital_status_named }}</vs-list-item>
                            <vs-list-item title="Dependientes económicos">{{
                                personal.credit_profile.economic_dependents || "--" }}</vs-list-item>
                            <template v-if="personal.marital_status == 2">
                                <vs-list-item title="Nombre del cónyuge">{{ personal.companion_name }}</vs-list-item>
                                <vs-list-item title="Teléfono de cónyuge">{{ phoneFormat(personal.companion_phone)
                                }}</vs-list-item>
                                <vs-list-item title="Correo de cónyuge">{{ personal.companion_email }}</vs-list-item>
                            </template>
                            <vs-list-item title="Auto propio">{{
                                booleanFormat(personal.credit_profile.has_motorized_vehicles)
                            }}</vs-list-item>
                            <vs-list-item title="Seguro de gastos médicos mayores">{{
                                booleanFormat(personal.credit_profile.major_medical_health_insurance) }}</vs-list-item>
                        </template>
                    </vs-list>
                    <template v-if="!guaranteeIsMoral">
                        <vs-divider></vs-divider>
                        <h6 class="success bold">OCUPACIÓN</h6>
                        <vs-list>
                            <template>
                                <vs-list-item title="Ocupación">{{ personal.occupation.name }}</vs-list-item>
                                <vs-list-item title="Sector">{{ personal.personal_business_activity ?
                                    personal.personal_business_activity.sector_name : "--" }}</vs-list-item>
                                <vs-list-item title="Actividad principal">{{ personal.personal_business_activity ?
                                    personal.personal_business_activity.name : "--" }}</vs-list-item>
                                <vs-list-item title="Afiliación al IMSS">{{
                                    booleanFormat(personal.credit_profile.social_security_affiliated) }}</vs-list-item>
                            </template>
                        </vs-list>
                    </template>
                </div>
            </div>
        </div>

        <!-- informacion del telefono del solicitante -->
        <user-phone-status v-show="false" class="w-full" :user-id="source.client.user.id" @updated="onPhoneUpdated"
            ref="userPhoneForm" />

        <vs-popup v-if="satProfilePrompt" id="syntage-detail" :active.sync="satProfilePrompt"
            title="Detalle conexión con Syntage">
            <div class="vx-row">
                <div class="vx-col w-full mb-4">
                    <vx-card>
                        <h3 class="bold">Detalle conexión de RFC <span class="primary">{{ rfcSelected }}</span></h3>
                        <p class="text-sm mb-0">
                            Consulta los intentos de conexión con Syntage para el RFC seleccionado a través de su clave
                            CIEC. La
                            tabla se encuentra ordenada por fecha de intento más reciente al más antiguo.
                        </p>
                    </vx-card>
                </div>
                <div class="vx-col w-full">
                    <vx-card>
                        <vs-table ref="jobsTable" stripe pagination max-items="20" :data="satProfileData.profiles"
                            noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th>PROCESADOR</vs-th>
                                <vs-th>ID DE PROCESO</vs-th>
                                <!-- <vs-th>RFC</vs-th> -->
                                <vs-th>ESTATUS (RAW)</vs-th>
                                <vs-th>ESTATUS OPERATIVO</vs-th>
                                <vs-th>FECHA DE CONSULTA</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td>{{ tr.sat_processor }}</vs-td>
                                    <vs-td>{{ tr.sat_processor_uuid }}</vs-td>
                                    <!-- <vs-td>{{ tr.rfc }}</vs-td> -->
                                    <vs-td>{{ tr.credential_status }}</vs-td>
                                    <vs-td>{{ translateSyntageStatus(tr.credential_status) }}</vs-td>
                                    <vs-td>{{ sessionFormat(tr.created_at) }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import UserPhoneStatus from "@projects/UserPhoneStatus";
import dateHelper from "@mixins/dateHelper";
import userIdentityHelper from "../../../../../helpers/userIdentityHelper";
import projectStatusesHelper from "@mixins/projectStatusesHelper";
import { mapActions } from 'vuex';
import UserEmailsSentList from "@components/profile_shared/UserEmailsSentList";
import StpButton from "@components/stp/StpButton";

const PF_GUARANTEE_ONBOARDING = [
    { id: 'os_pf_ap_tc_acceptance', name: 'os_pf_ap_tc_acceptance' },
    { id: 'os_pf_basic_info', name: 'os_pf_basic_info' },
    { id: 'os_pf_rfc_curp', name: 'os_pf_rfc_curp' },
    { id: 'os_pf_address', name: 'os_pf_address' },
    { id: 'os_pf_credit_history', name: 'os_pf_credit_history' },
    { id: 'os_pf_identity_verification', name: 'os_pf_identity_verification' },
];

const PM_GUARANTEE_ONBOARDING = [
    { id: 'os_pm_ap_tc_acceptance', name: 'os_pm_ap_tc_acceptance' },
    { id: 'os_pm_basic_info', name: 'os_pm_basic_info' },
    { id: 'os_pm_address', name: 'os_pm_address' },
    { id: 'os_pm_sat', name: 'os_pm_sat' },
    { id: 'os_pm_credit_history', name: 'os_pm_credit_history' },
    { id: 'os_pm_rep_legal', name: 'os_pm_rep_legal' },
    { id: 'os_pm_rep_legal_curp_rfc', name: 'os_pm_rep_legal_curp_rfc' },
    { id: 'os_pm_rep_legal_identity_verification', name: 'os_pm_rep_legal_identity_verification' },
];

export default {
    name: "ProfileDetail",
    mixins: [
        formatHelper,
        dateHelper,
        userIdentityHelper,
        projectStatusesHelper
    ],
    props: {
        source: {
            type: Object,
            default: {},
            required: true
        },
        incomeSourcesData: {
            type: Array,
            required: false,
            default: () => []
        },
        guaranteeRequired: {
            default: () => false,
            type: Boolean,
            required: false,
        },
        guarantee: {
            type: Object,
            default: () => { },
            required: false
        },
        canEdit: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    mounted() {
        if (this.guaranteeRequired) {
            this.stepSelected = this.guarantee.guarantee_profile_step;
        }
    },
    components: {
        UserPhoneStatus,
        UserEmailsSentList,
        StpButton
    },
    data: () => ({
        editGuarnaateeOnboarding: false,
        PF_GUARANTEE_ONBOARDING: PF_GUARANTEE_ONBOARDING,
        PM_GUARANTEE_ONBOARDING: PM_GUARANTEE_ONBOARDING,
        stepSelected: null,
        satProfilePrompt: false,
        satProfileData: [],
        rfcSelected: null,
        btnConfig: {
            type: "border",
            color: "primary",
            size: "small"
        },
    }),
    computed: {
        isMoral() {
            return this.source.client.user.person_type == 0;
        },
        guaranteeIsMoral() {
            if (this.guaranteeRequired) {
                return this.guarantee.business_profile_id != null;
            }
        },
        // guarantee() {
        //     if(this.guaranteeRequired) {
        //         return this.finance.guarantee.guarantee_profile;
        //     }
        // },
        guaranteeAddress() {
            if (this.guaranteeRequired) {
                if (this.guaranteeIsMoral) {
                    return this.guarantee.business.address;
                } else {
                    return this.guarantee.personal.address;
                }
            }
        },
        guaranteeOwnerAddress() {
            if (this.guaranteeRequired) {
                return this.guarantee.business.personal.address;
            }
        },
        user() {
            return this.source.client.user;
        },
        supplier() {
            return this.source.supplier;
        },
        supplier_agent() {
            return this.source.agent;
        },
        applicant() {
            return this.source.client;
        },
        finance() {
            return this.source.finance;
        },
        personal() {
            if (this.guaranteeRequired) {
                return this.guarantee.personal;
            }
            return this.source.client.user.personal;
        },
        business() {
            if (this.guaranteeRequired) {
                return this.guarantee.business;
            }
            return this.source.client.user.business;
        },
        business_personal() {
            if (this.guaranteeRequired) {
                return this.guarantee.business.personal;
            }
            return this.source.client.user.business.personal;
        },
        address() {
            if (this.isMoral) {
                return this.business.address;
            } else {
                return this.personal.address;
            }
        },
        business_personal_address() {
            return this.business_personal.address;
        },
        applicantName() {
            if (this.isMoral) {
                return this.business.name
            }
        },
        profileId() {
            if (this.isMoral) {
                return this.business.id;
            } else {
                return this.personal.id;
            }
        },
        mainRole() {
            if (this.isMoral) {
                return "pm_income_source";
            } else {
                return "pf_income_source";
            }
        },
        hasIncomeSources() {
            return this.incomeSourcesData.length > 0;
        },
        mainIncomeSource() {
            if (this.hasIncomeSources) {
                return this.incomeSourcesData[0];
            } else {
                return null;
            }
        },
        currentStepList() {
            return this.guaranteeIsMoral ? this.PM_GUARANTEE_ONBOARDING : this.PF_GUARANTEE_ONBOARDING;
        }
    },
    methods: {
        ...mapActions('projects', [
            'requestGuaranteeReminder'
        ]),
        async executeRequestGuaranteeReminder(guaranteeId, reminderType) {
            this.showLoading(true);
            await this.requestGuaranteeReminder({
                guaranteeId: guaranteeId
                , flow: reminderType
            });
            this.showLoading(false);
        },
        openUserPhoneForm() {
            this.$refs.userPhoneForm.openPopup();
        },
        onPhoneUpdated(e) {
            this.personal.phone.phone = e;
        },
        async requestUpdateGuaranteeOnboarding() {
            try {
                this.showLoading(true);
                await axios.post(`api/guarantee/update/onboarding/${this.guarantee.id}/onboarding-step`, {
                    onboarding_step: this.stepSelected,
                    guarantee_id: this.guarantee.id

                });
                this.showLoading(false);
                this.saveSuccessNotif();
                this.guarantee.guarantee_profile_step = this.stepSelected;
                this.editGuarnaateeOnboarding = false;
            } catch (error) {
                this.showLoading(false);
                console.log(error);
                this.failedOperationNotif();
            }
        },
        async getSatProfiles(rfc) {
            try {
                this.showLoading(true);
                const res = await axios.post(`api/sat/post/profiles-by-rfc`, {
                    rfc: rfc,
                    password: "",
                    type: "ciec"
                });
                this.rfcSelected = rfc;
                this.satProfileData = res.data;
                this.satProfilePrompt = true;
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                this.missingFieldsNotif(null, "No hemos podido obtener la información de SAT. Por favor, intenta más tarde.");
            }
        },
        goToCdcService(personalProfileId) {
            window.open('/score/personal-profile/' + personalProfileId, '_blank')
        },
        showEmails(ref) {
            this.$refs[ref].getEmailsList();
        },
    }
}
</script>

<style>
#syntage-detail .vs-popup {
    width: 60% !important;
}

.text-align-right {
    text-align: right;
}
</style>